// extracted by mini-css-extract-plugin
module.exports = {"component":"companions-chip-list_component__REbeJ"};